module.exports = __webpack_public_path__ + "static/img/kh-17.4e24a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-17.png
// module id = qOuJ
// module chunks = 5